import { ASSET_NAVIGATION_LIST } from './NavigationTypes'
const initialState = {
   menuListAssetInventory : []
}

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ASSET_NAVIGATION_LIST:
      return {
        ...state,
        menuListAssetInventory: action.payload,
      }     
    default: return state
  }
}

export default reducer
